module.exports = __webpack_public_path__ + "img/mlc__19121802.c4a249f2.jpg";